import { render, staticRenderFns } from "./AskProvenance.vue?vue&type=template&id=6f73b602&"
import script from "./AskProvenance.vue?vue&type=script&lang=js&"
export * from "./AskProvenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports